import {NetworkModule} from '@fantasmagames/slot/src/modules/network/NetworkModule';
import {GameNetworkBasicState} from 'src/network/states/GameNetworkBasicState';

export class GameNetworkModule extends NetworkModule {
	protected setupStates(): void {
		super.setupStates();
		this.addState(new GameNetworkBasicState(this, NetworkModule.BASIC_STATE));
	}

	protected setupEvents(): void {
		super.setupEvents();
	}
}



// WEBPACK FOOTER //
// ./src/network/GameNetworkModule.ts